export default __webpack_public_path__ + "static/media/ceramol-gel-viso.85156b76.png";